import { defineMessages } from 'react-intl';

export default defineMessages({
  startTab: {
    description: 'Order Routing Configuration modal start tab',
    defaultMessage: 'Order Routing',
    id: 'quungY',
  },
  csvUploadTab: {
    description: 'Order Routing Configuration modal CSV upload tab',
    defaultMessage: 'Ship From Locations',
    id: 'iIxluq',
  },
  selectActiveShippingLocationsTab: {
    description: 'Order Routing Configuration modal CSV upload tab',
    defaultMessage: 'Select Default Shipping Locations',
    id: 'cTmZp2',
  },
  saveConfigurationTab: {
    description: 'Order Routing Configuration modal Save Configuration tab',
    defaultMessage: 'Save Setup',
    id: '+doTsX',
  },
  exportCsvTab: {
    description: 'title for the step in the Order Routing Configuration modal that allows you to export the CSV',
    defaultMessage: 'Products',
    id: 'XZ1FFq',
  },
  backButton: {
    description: 'buttons that allows the user to navigate back to the previous step',
    defaultMessage: 'Back',
    id: 'g4yp3T',
  },
  continueSetup: {
    description: 'buttons that allows the user to move to the next step in the setup',
    defaultMessage: 'Continue',
    id: '+RdbF2',
  },
  finishSetup: {
    description: 'buttons that allows the user to move to the next step in the setup',
    defaultMessage: 'Save Setup',
    id: 'MwVujr',
  },
  updateButton: {
    description: 'buttons that allows the user to move to the next step in the setup',
    defaultMessage: 'Update',
    id: 'aurYO1',
  },
  welcomeToAutoRouting: {
    description: 'title for the start step in the Order Routing Configuration modal',
    defaultMessage: 'Welcome to Order Routing',
    id: 'UiYSZL',
  },
  whatDoesAutoRoutingDo: {
    defaultMessage: 'Order Routing automatically assigns Ship From Locations to shipments by:',
    id: '1fWEww',
    description: 'intro sentence to start discussing what Order Routing does',
  },
  descriptionOfWhatAutoRoutingDoes1: {
    defaultMessage: 'First, determining which active locations contain the order’s products',
    id: 'xiMqjc',
    description: 'description of what Order Routing does',
  },
  descriptionOfWhatAutoRoutingDoes2: {
    defaultMessage: 'Then, analyzing whether or not all products can be shipped from a single location',
    id: 'ZDEfq6',
    description: 'description of what Order Routing does',
  },
  descriptionOfWhatAutoRoutingDoes3: {
    defaultMessage: 'Then, it creates shipments assigned to the active ship from location(s) nearest to the recipient’s address',
    id: 'JTbr8n',
    description: 'description of what Order Routing does',
  },
  saveAutoRouting: {
    description: 'title for the last step in the Order Routing Configuration modal',
    defaultMessage: 'Save Order Routing Setup',
    id: 'OeI4hP',
  },
  chooseActiveShippingLocations: {
    description: 'title for the step in the Order Routing Configuration modal that allows you to choose default Active Shipping Locations',
    defaultMessage: 'Choose Active Shipping Locations',
    id: 'bNOVne',
  },
  uploadActiveShippingLocations: {
    description: 'title for the step in the Order Routing Configuration modal that allows import Active Shipping Locations',
    defaultMessage: 'Upload Product CSV with Active Ship Froms',
    id: 'N4aAlQ',
  },
  exportCsvStep: {
    description: 'title for the step in the Order Routing Configuration modal that allows you to export the CSV',
    defaultMessage: 'Product CSV Export',
    id: 'BkApyo',
  },
  exportProductCSVButtonLabel: {
    description: 'label for the button that will export the CSV for all products',
    defaultMessage: 'Export Product CSV',
    id: 'XzyBkc',
  },
  autoRoutingSetup: {
    description: 'title for the 2nd section on the Order Routing Configuration modal',
    defaultMessage: 'Order Routing Setup',
    id: 'XEXbY5',
  },
  autoRoutingSetupInstructions1: {
    defaultMessage:
      'Order Routing requires that your products be assigned to the <link>Ship From Locations</link> from where they are fulfilled.',
    id: 'zVX7B/',
    description: 'instructions for setting up Order Routing',
  },
  autoRoutingSetupInstructions2: {
    defaultMessage: 'Click <b>Continue</b> to begin the guided setup.',
    id: 'Ypmr7X',
    description: 'instructions for setting up Order Routing',
  },
  createAProductFile: {
    defaultMessage: 'Create a Product File',
    id: 'Na4HFw',
    description: 'title for the step in the Order Routing Configuration modal that allows you to download and example product file',
  },
  directionsForCreatingAProductFile1: {
    defaultMessage:
      'The first step is to create a CSV file containing all products to be included in Order Routing. Later in the setup, the CSV file will be used to assign the active Ship From Locations to each product.',
    id: 'mqxl2t',
    description: 'directions for creating a product file',
  },
  directionsForCreatingAProductFileStep1: {
    defaultMessage: 'Click the <b>Export Product CSV</b> button to download a CSV file containing the products currently in ShipStation.',
    id: 'TsNcx9',
    description: 'directions for creating a product file',
  },
  directionsForCreatingAProductFileStep2: {
    defaultMessage:
      'Review the products contained in the file. Enter the <b>SKU</b> and <b>Product Name</b> for additional products, not currently in the file, that need to be included in Order Routing.',
    id: 'BW6ATr',
    description: 'directions for creating a product file',
  },
  directionsForCreatingAProductFileStep3: {
    defaultMessage: 'Be sure to save your changes.',
    id: 'gPno0q',
    description: 'directions for creating a product file',
  },
  directionsForCreatingAProductFile2: {
    defaultMessage: 'Next, you will associate the products in the file with their active Ship From Locations. Click <b>Continue</b>.',
    id: 'zjXE7P',
    description: 'directions for creating a product file',
  },
  addShipFromLocations: {
    defaultMessage: 'Add Ship From Locations & Upload File',
    id: 'cj+hax',
    description: 'title for the step in the Order Routing Configuration modal that allows you upload your Product File Ship From Locations',
  },
  directionsForEditingProductFile1: {
    defaultMessage: 'Next, update the file with the Ship From Location(s) associated with each product.',
    id: 'sRpgOg',
    description: 'directions for editing a product file',
  },
  directionsForEditingProductFile2: {
    defaultMessage: 'Click <b>Continue</b> once the file has been successfully uploaded.',
    id: 'qVfxS7',
    description: 'directions for editing a product file',
  },
  directionsForEditingProductFileStep1: {
    defaultMessage: 'Enter the Ship From Location(s) for each product into the <b>Active Ship From</b> column.',
    id: 't25NuX',
    description: 'directions for editing a product file',
  },
  directionsForEditingProductFileStep2: {
    defaultMessage:
      'Be sure that Active Ship From location names are spelled correctly and that multiple Ship From locations are separated by the pipe symbol ( | ). <i>Add a pipe symbol by pressing SHIFT + \\ on your keyboard.</i>',
    id: 'B27MG8',
    description: 'directions for editing a product file',
  },
  directionsForEditingProductFileStep3: {
    defaultMessage: '<b>Save</b> and close your file.',
    id: 'WWgZdq',
    description: 'directions for editing a product file',
  },
  directionsForEditingProductFileStep4: {
    defaultMessage: 'Click the <b>Upload File</b> button and follow the steps to upload your file to ShipStation.',
    id: 'ZHXet2',
    description: 'directions for editing a product file',
  },
  uploadFileButtonLabel: {
    defaultMessage: 'Upload File',
    id: 'zTWvlc',
    description: 'label for the button that will upload the product file',
  },
  directionsForEditingProductFileImageTitle: {
    defaultMessage: 'Example of Properly Entered Ship From Locations',
    id: 'fZYR2j',
    description: 'label that describes the image being displayed',
  },
  setupAutoRoutingCompleteParagraph1: {
    defaultMessage:
      'Order Routing is configured to route orders using the Active Ship From Locations assigned to your products in the uploaded file.',
    id: 'pB8Ize',
    description: 'paragraph that explains what happens after the user has completed the setup',
  },
  directionToCompleteAutoRoutingSetup: {
    defaultMessage: 'Click <b>Save Setup</b> to confirm your Order Routing configuration.',
    id: 'ILHvA1',
    description: 'directions for completing the Order Routing setup',
  },
  whatHappenAfterAutoRoutingSetupComplete: {
    defaultMessage:
      'You will be taken to the <b>Order Routing</b> page to review the Ship From Locations assigned to your products and to enable Order Routing.',
    id: 'sCoaj+',
    description: 'paragraph that explains what happens after the user has completed the setup',
  },
  fileUploadedLabel: {
    defaultMessage: 'File Uploaded',
    id: 'uzZJmW',
    description: 'displays on the File Upload step once the file is uploaded',
  },
  fileStatusExportSuccessful: {
    defaultMessage: 'Export Successful',
    id: 'ZK/0uQ',
    description: 'message displayed once the CSV file has been exported successfully',
  },
  productImportStartedDuringSetup: {
    defaultMessage:
      'Your product import has started. This may take a while so feel free to continue with your setup. You will receive a notification when your import is complete.',
    id: 'Tg+wfY',
    description: 'message displayed after the user starts their upload while running through the setup wizard',
  },
  productExportStartedDuringSetup: {
    defaultMessage:
      'Your product export has started. This may take a while so feel free to continue with your setup. Your file will download automatically once complete.',
    id: 'bgT5jH',
    description: 'message displayed after the user starts their export of the example product file while running through the setup wizard',
  },
});
